import ShortcutIcon from '@mui/icons-material/Shortcut';
import { Button, Tooltip, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

function BackButton() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Tooltip title={<FormattedMessage id="BACK" defaultMessage="Back" />} arrow>
      <Button
        variant="contained"
        sx={{
          boxShadow: theme.shadows[4],
          position: 'absolute',
          right: '15px',
          top: '120px',
          backgroundColor: 'background.paper',
          paddingLeft: '10px',
          paddingRight: '10px',
          minWidth: '0px',
          color: 'text.primary',
          ':hover': {
            backgroundColor: 'neutral.default',
          },
        }}
        onClick={() => navigate(-1)}>
        <ShortcutIcon sx={{ transform: 'scale(-1, 1)' }} />
        <FormattedMessage id="BACK" defaultMessage="Back" />
      </Button>
    </Tooltip>
  );
}

export default BackButton;
